import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './contact-bar.css';
import '../../../icon/icon.js';

/**
 * @property {string} headline
 * @property {Array} cards
 * @property {ImageProperties} image - Image object with src, srcset, alt
 */
export default class ContactBar extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            headline: '',
            cards: [],
            image: undefined,
        };
    }

    template() {
        return html`<div class="flex flex-col w-full md:gap-32 gap-16">
            <div class="flex flex-row place-content-center items-center gap-16 md:gap-32 w-full md:w-auto">
                ${when(
                    this.image?.src,
                    html`
                        <div class="relative max-h-[70px] aspect-square content-center">
                            <img
                                loading="lazy"
                                src="${this.image?.src}"
                                srcset="${this.image?.srcset}"
                                sizes="70px"
                                alt="${this.image?.alt || ''}"
                                class="object-contain h-full w-full"
                            />
                        </div>
                    `,
                )}
                <h2 class="text-[32px] md:text-[42px]">${this.headline}</h2>
            </div>
        </div> `;
    }
}

defineElement('mb-contact-bar', ContactBar);
